export default function JoinIcon({ className }: { className?: string }) {
  return (
    <span className={`relative ${className}`}>
      <svg className="absolute top-0 left-0 w-full h-full fill-current" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.1008 8.02574L12.6673 10.5923L10.1008 13.1588L9.36747 12.4255L10.6824 11.1104L3.8525 11.1108V10.0738L10.6824 10.0734L9.36747 8.75902L10.1008 8.02574ZM5.90052 2.84058L6.63382 3.57387L5.31887 4.8882L12.1488 4.88859V5.92562L5.31887 5.92523L6.63382 7.24034L5.90052 7.97363L3.33398 5.4071L5.90052 2.84058Z" />
      </svg>
    </span>
  );
}
